var _circle, _circle2, _circle3, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCursor = function SvgCursor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 48,
    fill: "#16D629"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 48,
    fill: "#2EDB43"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 48,
    fill: "#45E655"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.931 40.17 61 51.084m0 0L49.931 62M61 51.085H38a3 3 0 0 1-3-3V34",
    stroke: "#101111",
    strokeWidth: 2
  })));
};
export { SvgCursor as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOTYiIGhlaWdodD0iOTYiIHZpZXdCb3g9IjAgMCA5NiA5NiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iNDgiIGN5PSI0OCIgcj0iNDgiIGZpbGw9IiMxNkQ2MjkiLz4KPGNpcmNsZSBjeD0iNDgiIGN5PSI0OCIgcj0iNDgiIGZpbGw9IiMyRURCNDMiLz4KPGNpcmNsZSBjeD0iNDgiIGN5PSI0OCIgcj0iNDgiIGZpbGw9IiM0NUU2NTUiLz4KPHBhdGggZD0iTTQ5LjkzMTMgNDAuMTY5NUw2MSA1MS4wODQ3TTYxIDUxLjA4NDdMNDkuOTMxMyA2Mk02MSA1MS4wODQ3SDM4QzM2LjM0MzEgNTEuMDg0NyAzNSA0OS43NDE2IDM1IDQ4LjA4NDdWMzQiIHN0cm9rZT0iIzEwMTExMSIgc3Ryb2tlLXdpZHRoPSIyIi8+Cjwvc3ZnPgo=";